import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, CollapseCard } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import { ScoreIcon } from 'fable/ScoreIcon';
import '../../../styles/cards.less';
const DEFAULT_CSAT_LOOK_AND_FEEL = 'numbers';
export class FeedbackCard extends PureComponent {
    componentDidMount() {
        const { requestFeedback, csid } = this.props;
        requestFeedback({ csid });
    }
    componentDidUpdate(prevProps) {
        const { requestFeedback, csid } = this.props;
        if (prevProps.csid !== csid) {
            requestFeedback({ csid });
        }
    }
    render() {
        const { isOpen, isMinimized = false, onToggle, feedback } = this.props;
        if (!feedback) {
            return null;
        }
        const feedbackWithScore = feedback.filter(({ score }) => typeof score === 'number' && score > 0 && score < 6);
        if (feedbackWithScore.length === 0) {
            return null;
        }
        const avatar = _jsx(Avatar, { icon: "smile" });
        if (isMinimized) {
            return _jsx("div", Object.assign({ className: "icon-holder" }, { children: avatar }));
        }
        const average = feedbackWithScore.reduce((acc, { score }) => acc + (score || 0), 0) /
            feedbackWithScore.length;
        const explanation = `${average.toFixed(1).replace(/.0$/, '')} out of 5`;
        // get latest rated feedback
        const { score, comment, csat_look_and_feel: csatLookAndFeel, effective_customization: effectiveCustomization, } = feedback.slice().sort((a, b) => {
            if ((a === null || a === void 0 ? void 0 : a.rated_at) && (b === null || b === void 0 ? void 0 : b.rated_at)) {
                return -a.rated_at.localeCompare(b.rated_at);
            }
            return 1;
        })[0];
        const csatType = (effectiveCustomization === null || effectiveCustomization === void 0 ? void 0 : effectiveCustomization.look_and_feel) ||
            csatLookAndFeel ||
            DEFAULT_CSAT_LOOK_AND_FEEL;
        return (_jsxs(CollapseCard, Object.assign({ onToggle: onToggle, isOpen: isOpen, className: "feedback-card" }, { children: [_jsx(CollapseCard.Header, Object.assign({ avatar: avatar, title: "Satisfaction Rating" }, { children: "Satisfaction Rating" })), _jsxs(CollapseCard.Content, { children: [_jsx(CollapseCard.Line, Object.assign({ label: "Average Rating Score:" }, { children: explanation })), _jsx(CollapseCard.Line, Object.assign({ className: "feedback-latest", label: "Latest Rating Score:" }, { children: score && _jsx(ScoreIcon, { score: score, style: csatType }) })), _jsx("div", Object.assign({ className: "feedback-comment" }, { children: comment }))] })] })));
    }
}
